module.exports = __webpack_public_path__ + "img/1512835188.7a888040.jpg";